import { DatePipe } from '@angular/common';
import { ArrayLimitToPipe } from '../../filters/array-limit-to.pipe';
import { StartFromPipe } from '../../filters/start-from.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemNoContentComponent } from '../../components/item-no-content/item-no-content.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import Config from '../../utils/config.service';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'table-claims-history',
	templateUrl: './table-claims-history.component.html',
	imports: [
		CommonModule, DatePipe, ArrayLimitToPipe, StartFromPipe, 
		TranslatePipe, ItemNoContentComponent, LoaderOverlayComponent, 
		FormsModule, RouterLink
	]
})
export class TableClaimsHistoryComponent implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() pageSize: any | undefined;
	@Input() claimsList: any;
	@Output() claimsListChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() currentPage: any | undefined;
	@Output() currentPageChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.filter = {
			orderBy: 'unknown',
			ascending: false
		};
		this.vm.pageSize = this.vm.pageSize || 10;
		this.vm.currentPage = this.vm.currentPage || 0;
		this.vm.endReached = false;
		this.vm.claimsList = [];
		this.vm.loading = true;
		
		this.loadClaimsHistory(true, true);
		
		this.broadcastSubscriptions.push(this.angularBroadcastHelperService.onEvent(this, "loadMorePages",
			() => {
				if (!this.vm.endReached) {
					this.loadClaimsHistory();
				}
			})
		);
		
		this.vm.loadClaimsHistory = this.loadClaimsHistory;
		this.vm.setFilter = this.setFilter;
		this.vm.getPolicyDownloadUrl = this.getPolicyDownloadUrl;
	}
	
	ngOnDestroy() {
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	loadClaimsHistory(isInitial?, hasLoader?) {
		if (isInitial) {
			this.vm.endReached = false;
		} else if (this.vm.endReached) {
			this.vm.loading = false;
			return;
		}
		var params: any = {
			pageSize: this.vm.pageSize * 2,
			start: (!isInitial && this.vm.claimsList) ? this.vm.claimsList.length : 0
		};
		if (this.vm.term && this.vm.term.trim() && this.vm.term.trim().length > 2) params.name = this.vm.term.trim();
		
		this.restService.getUserClaimsList(params)
			.then((claimsList) => {
				if (claimsList && claimsList.length < this.vm.pageSize * 2) {
					this.vm.endReached = true;
				}
				if (isInitial) this.vm.currentPage = 0;
				if (hasLoader) {
					this.angularHelperService.createTimer(() => {
						this.vm.loading = false;
						this.vm.claimsList = isInitial ? claimsList : this.vm.claimsList.concat(claimsList);
						this.claimsListChange.emit(this.vm.claimsList);
					}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
				} else {
					this.vm.claimsList = isInitial ? claimsList : this.vm.claimsList.concat(claimsList);
					this.claimsListChange.emit(this.vm.claimsList);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}
	
	setFilter(name) {
		// Temporarily disabled
		// this.vm.filter = this.vm.filter || {};
		// this.vm.filter.ascending = this.vm.filter.orderBy === name ? !this.vm.filter.ascending : false;
		// this.vm.filter.orderBy = name;
		//
		// this.loadClaimsHistory(true);
	}
	
	getPolicyDownloadUrl(insurancePolicyId, policyNumber) {
		return this.config.getRestUrl() + 'insurance/api/v1/policy/' + insurancePolicyId + '/' + policyNumber + '.pdf';
	}
	
}